
const migrations = {
  0: (state: any) => {
    // Default migration.
    return state;
  }
};

export default migrations;
